<template>
    <div id="telematicsReadingList">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <template v-if="assetReadingVal != undefined">
            <div class="row">
                <div class="col-11 pr-0">
                    <data-table-filter-config :moduleName="'telematicListAssetView'" :allowSameFilter="'allow'"></data-table-filter-config>
                </div>
                <div class="col-1 col-1 pt-3">
                    <div class="btn-groups text-right mb-3">
                        <button type="submit" v-on:click="addOdometerReading()" class="btn btn-primary">
                            <i class="fp-add"> </i>  Add
                        </button>
                    </div>
                </div>
            </div>
            <div class="bg-white data-table p-0">
                <!-- <template v-if="(totalRecords > serverParams.perPage ? true:false)"> -->
                    <custom-pagination
                            :page-changed="onPageChange"
                            :per-page-changed="onPerPageChange" :moduleName="'telematicList'">
                    </custom-pagination>
                <!-- </template> -->
                <vue-good-table
                    ref="telematicsReadingList"
                    mode="remote"
                    title="Odometer Reading"
                    @on-page-change="onPageChange"
                    @on-column-filter="onColumnFilter"
                    @on-per-page-change="onPerPageChange"
                    @on-sort-change="onSortChange"
                    :totalRows="totalRecords"
                    :columns="columns"
                    :rows="rows"
                    :pagination-options="{
                        enabled: false,
                        position: 'both',
                        perPage: perPage,
                        perPageDropdown:dropDownPerPage,
                        dropdownAllowAll: false,
                    }"
                    :sort-options="{
                        enabled: true,
                        initialSortBy: {field: 'date', type: 'desc'}
                    }"
                    >
                </vue-good-table>
                <!-- <template v-if="(totalRecords > serverParams.perPage ? true:false)"> -->
                    <custom-pagination
                            :page-changed="onPageChange"
                            :per-page-changed="onPerPageChange">
                    </custom-pagination>
                <!-- </template> -->
            </div>
        </template>
        <div id="page-content-wrapper" class="admin-content-area reading-lists" v-else>
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title">Telematics Reading List </div>
                    <!-- Button for Clear Cache -->
                    <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data>
                    <div class="web-action-btn btn-groups text-right">
                        <router-link v-bind:to="'/asset-without-reading/list'" class="btn btn-secondary">
                            <i class="fp-truck-asset" ></i> Asset Without Reading
                        </router-link>
                        <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportCheck()">
                            <i class="fp-export"></i> Export
                        </a>
                        <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="openModal" >
                        <i class="fp-import"></i> Import
                        </a>
                        <router-link type="submit" class="btn btn-primary" v-bind:to="'/telematics-reading/create'" >
                            <i class="fp-add"></i> Add
                        </router-link>
                    </div>
                    <div class="mobile-action-btn elipse-btn">
                        <button type="button" class="btn btn-elipse" data-toggle="dropdown" data-toggle-position="left" aria-expanded="false" v-on:click.prevent="myFunction">
                            <i class="fp-ellipsis-v"></i>
                        </button>
                        <div id="myDropdown" class="dropdown-content">
                            <ul>
                                <li> <router-link v-bind:to="'/asset-without-reading/list'" >
                                    Asset Without Reading
                                    </router-link>
                                </li>
                                <li> <a href="javascript:void(0)" v-on:click="openModal">
                                        Import
                                    </a>
                                </li>
                                <li>
                                    <router-link type="submit" v-bind:to="'/telematics-reading/create'">
                                    Add
                                    </router-link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content telematics-reading-list">
                        <data-table-filter-config :moduleName="'telematicList'" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                        <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
                        <section class="data-table bg-white">
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange" :moduleName="'telematicList'" :position="'top'">
                                </custom-pagination>

                                <vue-good-table
                                    ref="telematicsReadingList"
                                    mode="remote"
                                    title="Odometer Reading"
                                    @on-page-change="onPageChange"
                                    @on-selected-rows-change="selectionChanged"
                                    @on-column-filter="onColumnFilter"
                                    @on-per-page-change="onPerPageChange"
                                    @on-sort-change="onSortChange"
                                    @on-cell-click="onCellClick"
                                    @on-select-all="onSelectAll"
                                    :totalRows="totalRecords"
                                    :columns="userColumns"
                                    :rows="rows"
                                    :pagination-options="{
                                        enabled: false,
                                        position: 'both',
                                        perPage: perPage,
                                        perPageDropdown:dropDownPerPage,
                                        dropdownAllowAll: false,
                                    }"
                                    :select-options="{
                                    enabled: canDeleteCustomer,
                                    selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                    selectionInfoClass: 'custom-class',
                                    selectionText: 'rows selected',
                                    clearSelectionText: 'clear',
                                    }"
                                    :sort-options="{
                                        enabled: true,
                                        initialSortBy: {field: 'created_at', type: 'desc'}
                                    }"
                                    :search-options="{
                                    enabled: false,
                                    }">

                                    <div slot="selected-row-actions">
                                        <button id="deleteCustomerContactBtn" v-on:click.prevent="ReadingDelete" class="btn btn-danger">Delete</button>
                                    </div>
                                </vue-good-table>
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange">
                                </custom-pagination>

                        </section>
                        <div class="modal fade invoice-modal update-reading-modal" id="myModal" ref="myModal" data-backdrop="static" data-keyboard="false" aria-labelledby="invModal" aria-hidden="true">
                                    <div class="modal-dialog" role="document">
                                        <div class="modal-content">
                                            <div class="modal-header">
                                                <h5 class="modal-title">Select File</h5>
                                            </div>
                                            <div class="modal-body">
                                                <form id="importFile" class="addinspectionForm basic-form-container">
                                                    <div class="form-row row-cols-md-1 row-cols-1">
                                                        <div class="col form-group">
                                                            <label class="control-label require" for="name">File:</label>
                                                            <input id="typeImage" type="file" @change="onFileChanged">
                                                            <br/>
                                                            <div class="" v-if="fileName != ''">
                                                                <label class="control-label"> Download Sample file for Reading </label>
                                                                <a href="javascript:void(0)" v-on:click="downloadSample()"> <i class="fp-text-document"></i> {{fileName}} </a>
                                                            </div>
                                                        </div>
                                                        <span class="field-error">{{error}}</span>
                                                        <template v-if="invalidData.length != 0">
                                                            <div class="modal-body" >
                                                                <table aria-describedby="table" class="table table-sm table-bordered font-1">
                                                                <thead>
                                                                    <tr class="table-primary">
                                                                    <th scope="col" class="w-10 require">SN</th>
                                                                    <th scope="col" class="w-45 require">Unit Number</th>
                                                                    <th scope="col" class="w-45 require">Reason</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <template v-for="(data, sn) in invalidData">
                                                                    <tr>
                                                                        <td>{{sn + 1}}</td>
                                                                        <td>{{data.unitno}}</td>
                                                                        <td>{{data.reason}}</td>
                                                                    </tr>
                                                                    </template>
                                                                </tbody>
                                                                </table>
                                                            </div>
                                                        </template>

                                                    </div>
                                                </form>
                                                <template v-if="notFoundArr.unit && notFoundArr.unit.length > 0">
                                                    <label class="d-block"> Reading Not Imported Because These Unit Not Available:</label>
                                                    <template v-for="(unit,unitKey) in notFoundArr.unit">
                                                        <a :key="unitKey+'u'" v-if="unitKey > 0"> &nbsp;&nbsp; | &nbsp;</a><span :key="unitKey+'u'">{{unit}}</span>
                                                    </template>
                                                </template>
                                                <template v-if="notFoundArr.type && notFoundArr.type.length > 0">
                                                    <label class="d-block"> Reading Not Imported Because Reading Type For These Unit Not Available:</label>
                                                    <template v-for="(typeData,typeKey) in notFoundArr.type">
                                                        <a :key="typeKey+'t'" v-if="typeKey > 0"> &nbsp;&nbsp; | &nbsp;</a><span :key="typeKey+'t'">{{typeData}}</span>
                                                    </template>
                                                </template>
                                                <template v-if="notFoundArr.period && notFoundArr.period.length > 0">
                                                    <label class="d-block"> Reading Not Imported Because Billing Date For These Unit Not Available:</label>
                                                    <template v-for="(periodData,periodKey) in notFoundArr.period">
                                                        <a :key="periodKey+'p'" v-if="periodKey > 0"> &nbsp;&nbsp; | &nbsp;</a><span :key="periodKey+'p'">{{periodData}}</span>
                                                    </template>
                                                </template>
                                                <template v-if="notFoundArr.reading && notFoundArr.reading.length > 0">
                                                    <label class="d-block"> Reading Not Imported Because Reading For These Unit Not Available In Uploaded File:</label>
                                                    <template v-for="(readingData,readingKey) in notFoundArr.reading">
                                                        <a :key="readingKey+'p'" v-if="readingKey > 0"> &nbsp;&nbsp; | &nbsp;</a><span :key="readingKey+'p'">{{readingData}}</span>
                                                    </template>
                                                </template>
                                            </div>
                                            <div class="modal-footer btm-action-btn-fl">
                                                <button class="btn btn-secondary" id="myButton" v-on:click="importReport()"> <i class="fp-import"> </i> Import</button>
                                                <button type="button" class="btn btn-tertiary" data-dismiss="modal"><i class="fp-close"></i>Cancel</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="modal fade invoice-modal update-reading-modal" id="readingModal" ref="readingModal" data-backdrop="static" data-keyboard="false" aria-labelledby="invModal" aria-hidden="true">
                                    <div class="modal-dialog" role="document">
                                        <div class="modal-content">
                                            <div class="modal-header">
                                                <h5 class="modal-title">Update Reading</h5>
                                            </div>
                                            <div class="modal-body">
                                                <form id="importFile" class="addinspectionForm telematics-reading-form">
                                                    <div class="form-row row-cols-md-2 row-cols-1">
                                                        <input class="form-control" id="unitNum" type="hidden" v-model="id">
                                                        <div class="col form-group">
                                                            <label class="control-label require" for="name">Unit Number:</label>
                                                            <input class="form-control" id="unitNum" type="text" v-model="unitNum" disabled='disabled'>
                                                        </div>
                                                        <div class="col form-group" v-if='!fromDate'>
                                                            <label class="control-label require" for="name">Reading Date:</label>
                                                            <input class="form-control" type="text" v-model="readingDate" id="readingDate" name="readingDate" disabled='disabled'>
                                                        </div>
                                                        <div class="col form-group" v-if='fromDate'>
                                                            <label class="control-label require" for="name">From Date:</label>
                                                            <input class="form-control"  type="text" v-model="fromDate" id="fromDate" name="fromDate" disabled='disabled'>
                                                        </div>
                                                        <div class="col form-group" v-if='fromDate'>
                                                            <label class="control-label require" for="name">Reading Date:</label>
                                                            <input class="form-control" type="text" v-model="readingDate" id="readingDate" name="readingDate" disabled='disabled'>
                                                        </div>
                                                        <div class="col form-group">
                                                            <label class="control-label require" for="name">Reading</label>
                                                            <input class="form-control" type="text" v-model="reading" id="reading" name="reading" @keypress="isAmountCheck($event)"/>
                                                            <span class="field-error">{{readingError}}</span>
                                                        </div>
                                                        <div class="col form-group mt-4">
                                                            <span>{{unit}}</span>
                                                        </div>
                                                        <div class="col form-group">
                                                            <label class="control-label require" for="name">LTD Reading</label>
                                                            <input class="form-control" type="text" v-model="ltd_reading" id="ltd_reading" name="ltd_reading" @keypress="isAmountCheck($event)"/>
                                                            <span class="field-error">{{ltd_readingError}}</span>
                                                        </div>
                                                        <div class="col form-group mt-4">
                                                            <span>{{unit}}</span>
                                                        </div>
                                                        <div class="col form-group">
                                                            <label class="control-label" for="name">Actual:</label>
                                                            <div class="custome-radiobtn">
                                                                    <div class="form-check form-check-inline">
                                                                        <label class="boolean optional radio-custom" for="misc1_eligible"> Yes
                                                                            <input type="radio" v-model="actual_change" :value="1" id="misc1_eligible" name="isAccurate">
                                                                            <span class="checkmark"></span>
                                                                        </label>
                                                                    </div>
                                                                    <div class="form-check form-check-inline">
                                                                        <label class="boolean optional radio-custom" for="misc2_eligible"> No
                                                                            <input type="radio" v-model="actual_change" :value="0" id="misc2_eligible" name="isAccurate">
                                                                            <span class="checkmark"></span>
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                        </div>
                                                        <div v-if="canAddMeterChange === true" class="col form-group">
                                                            <label class="control-label" for="name">Meter Change:</label>
                                                                <div class="custome-radiobtn">
                                                                    <div class="form-check form-check-inline">
                                                                        <label class="boolean optional radio-custom" for="misc3_eligible"> Yes
                                                                            <input type="radio" v-model="meter_change" :value="1" id="misc3_eligible" name="meterChange">
                                                                            <span class="checkmark"></span>
                                                                        </label>
                                                                    </div>
                                                                    <div class="form-check form-check-inline">
                                                                        <label class="boolean optional radio-custom" for="misc4_eligible"> No
                                                                            <input type="radio" v-model="meter_change" :value="0" id="misc4_eligible" name="meterChange">
                                                                            <span class="checkmark"></span>
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                        </div>
                                                        <div class="col form-group">
                                                            <label class="control-label" for="name">Is Billing:</label>
                                                                <div class="custome-radiobtn">
                                                                    <div class="form-check form-check-inline">
                                                                        <label class="boolean optional radio-custom" for="misc5_eligible"> Yes
                                                                            <input type="radio" v-model="is_billing" :value="1" id="misc5_eligible" name="isBilling">
                                                                            <span class="checkmark"></span>
                                                                        </label>
                                                                    </div>
                                                                    <div class="form-check form-check-inline">
                                                                        <label class="boolean optional radio-custom" for="misc6_eligible"> No
                                                                            <input type="radio" v-model="is_billing" :value="0" id="misc6_eligible" name="isBilling">
                                                                            <span class="checkmark"></span>
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                            <div class="modal-footer btm-action-btn-fl">
                                                <button class="btn btn-primary" id="readingButton" v-on:click="updateReading()"> <i class="fp-reload"> </i> Update</button>
                                                <button type="button" class="btn btn-tertiary" data-dismiss="modal"> <i class="fp-close"> </i> Cancel</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>

import Vue from "vue";

import EventBus from "./../event-bus";


import {commonMixins} from '../../mixins/commonMixins';
import {dataTableMixins} from '../../mixins/dataTableMixins';
    export default {
        name: "readingList",
        mixins:[commonMixins,dataTableMixins],
        props: {
            assetReadingVal: {
                type: String,
                required: false,
                default: undefined
            },
        },

        data: () => ({
            firstLoad: 0,
            permissions: [],
            cantAccessPage: "",
            canAddMeterChange: false,
            selectedFile:"",
            deviceType:"",
            error:"",
            notfound:false,
            notFoundArr:[],
            unitNum:"",
            reading:"",
            ltd_reading:"",
            section:"",
            actual_change:"",
            meter_change:"",
            is_billing:"",
            id:0,
            userColumns:[],
            canDeleteCustomer:true,
            columns: [
                {
                    label: 'Customer',
                    field: 'customer',
                    filterable: true,
                    fpFieldType:"text",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Customer", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Location',
                    field: 'location',
                    filterable: true,
                    fpFieldType:"option",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Location", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: '# Unit',
                    field: 'unit_no',
                    filterable: true,
                    fpFieldType:"text",
                    type: "number",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Unit Number", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Previous Customer',
                    field: 'prev_customer',
                    fpFieldType:"text",
                    filterable: false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Previous Customer", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    sortable:false,
                },
                {
                    label: 'Previous Reading Date',
                    field: 'pre_date',
                    fpFieldType:"date",
                    filterable: false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Previous Reading Date", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    sortable:false
                },
                {
                    label: 'Previous Reading',
                    field: 'pre_reading',
                    fpFieldType:"integer",
                    filterable: false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Previous Reading", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    sortable:false
                },
                {
                    label: 'Date',
                    field: 'date',
                    filterable: true,
                    fpFieldType:"date",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "MM/DD/YYYY", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Reading',
                    field: 'reading',
                    filterable: true,
                    fpFieldType:"integer",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Reading", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'LTD Reading',
                    field: 'ltd_reading',
                    filterable: true,
                    fpFieldType:"integer",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Reading", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Section',
                    field: 'section',
                    filterable: true,
                    fpFieldType:"text",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "section", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Source',
                    field: 'source',
                    filterable: true,
                    fpFieldType:"text",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "source", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Meter Change',
                    field: 'meter',
                    filterable: true,
                    fpFieldType:"option",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "All", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: ['Yes', 'No'],
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Is Accurate',
                    field: 'accurate',
                    fpFieldType:"option",
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "All", // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: ['Yes', 'No'],
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Is Billing',
                    field: 'is_billing',
                    fpFieldType:"option",
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "All", // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: ['Yes', 'No'],
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Input By',
                    field: 'type',
                    filterable: true,
                    fpFieldType:"text",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Input By", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: ['Customer', 'Device'],
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Device Name',
                    field: 'device_type',
                    fpFieldType:"text",
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Device Name", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Uploaded By',
                    field: 'uploaded_by',
                    filterable: true,
                    fpFieldType:"text",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Uploaded By", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Created At',
                    field: 'created_at',
                    filterable: true,
                    fpFieldType:"date",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "MM/DD/YYYY", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },


            ],
            rows: [],
            totalRecords: 0,
            customer_value: false,
            loading:false,
            fromDate:"",
            readingError:"",
            ltd_readingError:"",
            unit:"",
            readingDate:"",
            pageKey:"_odometer_list_",
            fileName:'',
            file:'',
            invalidData:[],
            action:'list',
            batchProcess:0,
            batchNum:"",
        }),
        metaInfo () {
            if (this.assetReadingVal == undefined) {
                return {
                    title: "Telematics Reading List | " +process.env.COPYRIGHT_NAME
                }
            }
        },
        watch:{

            //check permission change
            permissions: function (permissions) {

                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'odometer_reading_report') {
                            self.cantAccessPage = true;
                        }
                        if (permissions[i].name == 'add_meter_change') {
                            self.canAddMeterChange = true;
                        }
                    }
                }

            }

        },
        created: function() {

        },
        mounted: function() {

            var self = this;

            //when component list directly call from url instead of in view page than call permission request
            if ( self.assetReadingVal == undefined ) {
                self.getPermissions();
            }else{

                var path = window.location.pathname;
                var asset = path.split("/");
                self.assetId = asset[3];
                self.flag = 'selectedAssetReading';

                for (let index = 0; index < this.columns.length; index++) {
                    if(this.columns[index].field == 'unit_no' || this.columns[index].field == 'prev_customer' || this.columns[index].field == 'pre_date' || this.columns[index].field == 'pre_reading'){
                        this.$set(this.columns[index], 'hidden', true);
                    }
                }
                self.assetReadingVal = "loadList";
                // self.loadList();
            }
            //commented because request called double time in asset view when click on meter metrics
            //this.loadList();
        },
        methods: {
            addOdometerReading: function() {
              this.$emit('addOdometerReading',true);

            },
            cancelAll: function (cancelAll) {
              this.$refs.telematicsReadingList.unselectAllInternal();
            },

            selectionChanged(param) {
                var self = this;
                if(param.selectedRows.length == 100) {
                  EventBus.$emit('clear-selection', false);
                } else {
                  EventBus.$emit('clear-all-flags', false);
                }
                // console.log(self.computed.selectedRows);
                // var rowData = self.$refs['my-table'].selectedRows;
                // console.log(rowData);
            },

            loadList() {
                var self = this;

                if( self.assetReadingVal == 'dontLoadList' ) {
                    return;
                }
                var data = this.$refs['telematicsReadingList'].selectedRows;
                var arr = [];
                var use = [];
                for (var i = 0; i < data.length; i++) {
                    arr.push({
                        id: this.$refs['telematicsReadingList'].selectedRows[i].id,
                        unit_no: this.$refs['telematicsReadingList'].selectedRows[i].unit_no
                    });
                    use.push(this.$refs['telematicsReadingList'].selectedRows[i].id);
                }
                self.loading = true;
                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    sort: self.serverParams.sort,
                    flag: self.flag,
                    asset_id: self.assetId,
                    action:self.action,
                    all:self.serverParams.selectedAll,
                    id:arr,
                    selectedRows:use,
                };
                self.firstLoad = 1;
                $.ajax({
                    url: process.env.ROOT_API + "/reading/list",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        // console.log(data);
                        if (data.status == "success") {
                            // self.filteredFlag = false;
                            if ( self.action == "delete" ) {
                                self.action = "list";
                                if(data.status == "warning"){
                                    var messages = 'Readings for the following units have not been deleted as they are mapped with the invoices. <br>' + data.content;
                                    self.$swal('',messages ,'info');
                                    EventBus.$emit('clear-all-flags', false);
                                    self.loadList();
                                }else if (data.status == "success") {
                                    self.$swal('',data.message,'success');
                                    EventBus.$emit('clear-all-flags', false);
                                    self.loadList();
                                }
                            }else if ( self.action == "export" ||  self.action == "export_queue") {
                                    if ( data.code == "201" ) {
                                        alert(data.message);
                                    } else {
                                        if ( self.action == "export" ) {
                                            self.excel = data.content.web;
                                            var save = document.createElement("a");
                                            save.href = self.excel;
                                            save.download = data.content.web;
                                            save.target = "_blank";

                                            document.body.appendChild(save);
                                            save.click();
                                            document.body.removeChild(save);

                                        } else {

                                            self.batchProcess = 1;
                                            self.batchNum = data.content;
                                        }
                                    }
                                    self.action = "list";
                                    // self.loadList();
                            }else{
                                self.rows = data.content.row;
                                self.totalRecords = data.content.totalRecords;
                            }
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        if (jqXHR.status == 0) {
                            self.errorMsg = "Remote server cannot be reached";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("tkn");
                                self.$router.push("/");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });
            },
             onFileChanged (event) {
                const file = event.target.files[0]
                console.log(event.target);
                var self = this;
                self.selectedFile = file;
                self.notfound = false;
                self.notFoundArr = [];
                console.log(self.selectedFile);
            },
            openModal: function(){
                var self = this;
                self.notfound = false;
                self.invalidData = [];
                $('#myButton').text('Import');
                self.notFoundArr = [];
                self.selectedFile = "";
                self.error = "";
                $("#typeImage").val('');
                $.ajax({
                    url:
                    process.env.ROOT_API +
                    "/reading-excel/generate",
                    type: "POST",
                    crossDomain: true,
                    dataType: "json",
                    headers: this.ajxHeaders,

                    success: function(data) {
                        self.loading = false;
                        self.fileName = data.content.file;
                        self.file = data.content.web;

                    },
                    error: function(jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,true,'telematics-reading-import')

                    }
                });
                $('#myModal').modal('show');
            },
            importReport: function(){
                var self = this;

                if(self.selectedFile == "" || self.selectedFile == null){
                    self.error = "Please Select Excel File.";
                    return;
                }else{
                    self.error = "";
                }
                var formData = new FormData();
                formData.append('myFile', self.selectedFile);

                self.loading = true;
                $('#myButton').text('Fetching...');
                $('#myButton').prop('disabled',true);
                $.ajax({
                url: process.env.ROOT_API + "/reading/import",
                type: "POST",
                // data: {name: self.name, code: self.code, is_default: self.checkboxValue, id: segments[3]},
                data: formData,
                headers: this.ajxHeaders,
                crossDomain: true,
                processData: false,
                contentType: false,
                dataType: "json",
                success: function (data) {

                    $('#myButton').text('Import');
                    $('#myButton').prop('disabled',false);
                    self.loading = false;
                    self.invalidData = [];
                    if ( data.code == 201 ) {
                        if ( data.duplicate > 0 ) {
                            self.error = data.message;
                        } else if ( data.content.type || data.content.unit || data.content.period || data.content.reading) {
                            // if ( data.content.type ) {
                            //     self.error = "Reading type not found for this units :".data.content.type;
                            // } else if ( data.content.unit ) {
                            //     self.error = "This units not found in system :".data.content.unit;
                            // } else if ( data.content.period ) {
                            //     self.error = "Billing date not found for this units :".data.content.period;
                            // }
                            if ( Object.keys(data.content).length > 0){
                                self.notfound = true;
                                self.notFoundArr = data.content;
                            }
                            //self.error = "File format is wrong, Please use the same format as above Sample file.";
                        }else if (data.content.invalidData && Object.keys(data.content.invalidData).length > 0){
                            self.invalidData = data.content.invalidData;
                        } else {
                            self.error = "File format is wrong, Please use the same format as above Sample file.";
                        }

                        return;
                    }
                    if (data.status == "success") {
                        self.error = "";
                        if ( Object.keys(data.content).length > 0){
                            self.notfound = true;
                            self.notFoundArr = data.content;
                        }
                        $('#myModal').modal('hide');
                        self.$swal('',"Reading imported successfully",'success');
                        self.loadList();

                    }
                },
                error: function (jqXHR, exception) {
                    $('#myButton').text('Import');
                    $('#myButton').prop('disabled',false);
                   self.loading = false;
                    if (jqXHR.status == 0) {
                        self.errorMsg = "Remote server cannot be reached";
                    } else {
                        //redirect to login page if user not authenticated
                        if (jqXHR.status == 401) {
                            //clear previous data
                            localStorage.removeItem("user_obj");
                            localStorage.removeItem("tkn");

                            self.$router.push("/");
                        }
                    }
                }
            });
            },
            notifyCustomer: function(){
                var self = this;

                $.ajax({
                url: process.env.ROOT_API + "/reading/notification",
                type: "POST",
                // data: {name: self.name, code: self.code, is_default: self.checkboxValue, id: segments[3]},
                headers: this.ajxHeaders,
                crossDomain: true,
                processData: false,
                contentType: false,
                dataType: "json",
                success: function (data) {

                    self.loading = false;
                    if(data.code == 201){

                    }
                    if (data.status == "success") {


                    }
                },
                error: function (jqXHR, exception) {
                    $('#myButton').text('Import');
                    $('#myButton').prop('disabled',false);
                   self.loading = false;
                    if (jqXHR.status == 0) {
                        self.errorMsg = "Remote server cannot be reached";
                    } else {
                        //redirect to login page if user not authenticated
                        if (jqXHR.status == 401) {
                            //clear previous data
                            localStorage.removeItem("user_obj");
                            localStorage.removeItem("tkn");

                            self.$router.push("/");
                        }
                    }
                }
            });
            },
            onCellClick(params){
                var self = this;

                $.ajax({
                    url: process.env.ROOT_API + "/reading/info",
                    type: "GET",
                    data: {id:params.row.id},
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        // $("#myModal").modal('hide');
                        // console.log(data);
                        self.readingError = "";
                        self.ltd_readingError = "";
                        $("#readingModal").modal('show');
                        if (data.status == "success") {
                           console.log(data.content);
                           self.id = data.content.id;
                           self.reading = data.content.reading;
                           self.section = data.content.section;
                           self.unitNum = data.content.unit_No;
                           self.readingDate = data.content.reading_date;
                           self.fromDate = data.content.fromDate;
                           self.unit = data.content.unit;
                           self.actual_change = data.content.is_accurate;
                           self.meter_change = data.content.meter_change;
                           self.ltd_reading = data.content.ltd_reading;
                           self.is_billing = data.content.is_billing;
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        if (jqXHR.status == 0) {
                            self.errorMsg = "Remote server cannot be reached";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("tkn");
                                self.$router.push("/");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });
            },
            updateReading(){
                var self = this;

                if(!self.reading || self.reading == '' || self.reading < 1){
                    self.readingError = 'Please Provide Reading';
                    return;
                }
                if(!self.ltd_reading || self.ltd_reading == '' || self.ltd_reading < 1){
                    self.ltd_readingError = 'Please Provide Ltd Reading';
                    return;
                }

                if(parseInt(self.ltd_reading) < parseInt(self.reading)){
                    self.ltd_readingError = 'Ltd Reading should be greater than Reading';
                    return;
                }
                if(self.meter_change == 1 ){
                    self.$swal({
                            title: 'You have selected meter change "YES". Are you sure?',
                            type: 'info',
                            showCancelButton: true,
                            confirmButtonText: 'Yes',
                            cancelButtonText: 'No',
                            showCloseButton: false,
                            showLoaderOnConfirm: true
                        }).then((result) => {
                            if (result.value) {
                                self.callStoreRead();
                            } else {
                                return;
                            }
                        });
                }else{
                    self.callStoreRead();
                }
            },
            callStoreRead(){
                var self = this;
                $('#readingButton').text('Updating...');
                $('#readingButton').prop('disabled',true);
                $.ajax({
                        url: process.env.ROOT_API + "/reading/update",
                        type: "POST",
                        data: {id: self.id,reading:self.reading,actual_change:self.actual_change,meter_change:self.meter_change,ltd_reading:self.ltd_reading,is_billing:self.is_billing},
                        headers: this.ajxHeaders,
                        dataType: "json",
                        success: function (data) {
                            $('#readingButton').text('Update');
                            $('#readingButton').prop('disabled',false);
                            self.loading = false;
                            if(data.code == 201){
                            self.$swal('',data.message,'info');
                            return;
                            }
                            if (data.status == "success") {
                            $("#readingModal").modal('hide');
                            self.loadList();
                            }
                        },
                        error: function (jqXHR, exception) {
                            $('#readingButton').text('Update');
                            $('#readingButton').prop('disabled',false);
                        self.loading = false;
                            if (jqXHR.status == 0) {
                                self.errorMsg = "Remote server cannot be reached";
                            } else {
                                //redirect to login page if user not authenticated
                                if (jqXHR.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("tkn");

                                    self.$router.push("/");
                                }
                            }
                        }
                    });
            },
            downloadSample(){
                var self = this;
                // alert(self.file);
                // console.log()
                var docPath = self.file;
                var save = document.createElement('a');
                save.href = docPath;
                save.download = docPath;
                save.target = '_blank';
                document.body.appendChild(save);
                save.click();
                document.body.removeChild(save);
            },
            // Delete Reading
            ReadingDelete(){
                var self = this;
                self.$swal({
                    title: 'Are you sure that you want to delete this telematics reading ?',
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                    showCloseButton: false,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                        self.action = 'delete';
                        // self.loadList();
                        self.loadFilters('telematics');
                    } else {
                      console.log("no");
                    }
                });

                // var data = this.$refs['telematicsReadingList'].selectedRows;
                // var arr = [];
                // for (var i = 0; i < data.length; i++) {
                //     arr.push({
                //         id: this.$refs['telematicsReadingList'].selectedRows[i].id,
                //         unit_no: this.$refs['telematicsReadingList'].selectedRows[i].unit_no
                //     });
                // }
                // $.ajax({
                //     url: process.env.ROOT_API + "/reading/delete",
                //     type: "POST",
                //     data: {ids:arr},
                //     headers: {
                //         "Accept": "application/json",
                //         "Authorization": "Bearer " + localStorage.getItem("tkn"),
                //         "Access-Control-Allow-Headers":
                //             "Origin, Content-Type, Authorization,X-Requested-With",
                //         "Cache-Control": "no-cache"
                //     },
                //     dataType: "json",
                //     success: function (data) {
                //         // self.loading = false;

                //         if(data.status == "warning"){
                //             var messages = 'Readings for the following units have not been deleted as they are mapped with the invoices. <br>' + data.content;
                //             self.$swal('',messages ,'info');
                //             self.loadList();
                //         }else if (data.status == "success") {
                //         // $("#readingModal").modal('hide');
                //         self.$swal('',data.message,'success');
                //         self.loadList();
                //         }
                //     },
                //     error: function (jqXHR, exception) {
                //         $('#readingButton').text('Update');
                //         $('#readingButton').prop('disabled',false);
                //     self.loading = false;
                //         if (jqXHR.status == 0) {
                //             self.errorMsg = "Remote server cannot be reached";
                //         } else {
                //             //redirect to login page if user not authenticated
                //             if (jqXHR.status == 401) {
                //                 //clear previous data
                //                 localStorage.removeItem("user_obj");
                //                 localStorage.removeItem("tkn");

                //                 self.$router.push("/");
                //             }
                //         }
                //     }
                // });
            },
            exportCheck: function() {
                var count = 0;
                var actionFlag = "";
                var data = this.$refs['telematicsReadingList'].selectedRows;
                count = data.length;
                if(this.serverParams.selectedAll == true){
                    actionFlag = "";
                }else if(count != 0 && count <= 100){
                    actionFlag = "export";
                }
                this.exportReports(actionFlag);
            }
        }
    };
</script>




// WEBPACK FOOTER //
// src/components/telematicsReading/TelematicsReadingList.vue